import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import Icon from 'components/base/Icon';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import PieChart from 'components/PieChart';
import { PROJECTS } from '../services/projects.services';
import DeliverySummary from './DeliverySummary';

const InfoBox = styled(Flex)`
  border: 1px solid ${getColor('fog')};
  border-radius: 4px;
  width: 100%;
  max-width: 45rem;
`;

const InfoBoxTitle = styled(Flex)`
  padding: 0.7rem;
`;

const InfoBoxContent = styled(Flex)`
  background: ${getColor('zircon')};
  padding: 1rem;
`;

const DeliveryTypeColumn = ({ lineChartData, showVelocityPie }) => {
  const { totalValue, totalSuffix, totalText, icon, chartTitle, info } =
    lineChartData;

  return (
    <>
      {showVelocityPie && (
        <Flex items='center' data-testid='pieChart'>
          <PieChart
            data={[
              {
                name: chartTitle,
                value: totalValue,
                color: getColor('melrose')
              },
              {
                name: '',
                value: parseInt(100 - totalValue),
                color: getColor('botticelli')
              }
            ]}
            dataKey='value'
            pieSize={PROJECTS.LARGE_PIE_SIZE}
            showTooltip={false}
            noStroke={true}
          />
        </Flex>
      )}

      <DeliverySummary
        totalValue={totalValue}
        totalSuffix={totalSuffix}
        isShowIcon={false}
        icon={icon}
        title={totalText}
      />

      <InfoBox direction='column' ml='normal' mr='normal' data-testid='infoBox'>
        <InfoBoxTitle items='center'>
          <Icon name='bulb' color='deluge' size='x-small' />
          <Text
            color='deluge'
            textTransform='upperCase'
            pl='0.3rem'
            data-testid='infoBox-title'
          >
            {chartTitle}
          </Text>
        </InfoBoxTitle>
        <InfoBoxContent>
          <Text
            color='shuttleGray'
            lineHeight='1.4rem'
            data-testid='infoBox-text'
          >
            {info}
          </Text>
        </InfoBoxContent>
      </InfoBox>
    </>
  );
};

export default DeliveryTypeColumn;
